import {createSelector} from '@reduxjs/toolkit';

import {selectGeneralSettings} from '../generalSettings/selectors';

const selectSlice = createSelector(selectGeneralSettings, (state) => state?.documentSeries);

export const selectSeries = createSelector(selectSlice, (state) => state.series);
